import type React from "react"

export const Layout_1_1_1_1: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Layout 1-1-1-1</title>
    <path
      d="M3.74026 4.74026C3.74026 4.18798 4.18797 3.74026 4.74026 3.74026H16.4545C17.0068 3.74026 17.4545 4.18798 17.4545 4.74026V5.85714C17.4545 6.40943 17.0068 6.85714 16.4545 6.85714H4.74026C4.18797 6.85714 3.74026 6.40943 3.74026 5.85714V4.74026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M3.74026 9.72727C3.74026 9.17499 4.18797 8.72727 4.74026 8.72727H16.4545C17.0068 8.72727 17.4545 9.17499 17.4545 9.72727V10.8442C17.4545 11.3964 17.0068 11.8442 16.4545 11.8442H4.74026C4.18797 11.8442 3.74026 11.3964 3.74026 10.8442V9.72727Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M3.74026 14.7143C3.74026 14.162 4.18797 13.7143 4.74026 13.7143H16.4545C17.0068 13.7143 17.4545 14.162 17.4545 14.7143V15.8312C17.4545 16.3835 17.0068 16.8312 16.4545 16.8312H4.74026C4.18797 16.8312 3.74026 16.3835 3.74026 15.8312V14.7143Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M3.74026 19.7013C3.74026 19.149 4.18797 18.7013 4.74026 18.7013H16.4545C17.0068 18.7013 17.4545 19.149 17.4545 19.7013V20.8182C17.4545 21.3705 17.0068 21.8182 16.4545 21.8182H4.74026C4.18797 21.8182 3.74026 21.3705 3.74026 20.8182V19.7013Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M17.6623 0H3.53247C1.54545 0 0 1.48295 0 3.27273V22.9091C0 24.75 1.54545 26.1818 3.53247 26.1818H17.6623C19.5942 26.1818 21.1948 24.75 21.1948 22.9091V3.27273C21.1948 1.48295 19.5942 0 17.6623 0ZM19.4286 22.9091C19.4286 23.8295 18.6007 24.5455 17.6623 24.5455H3.53247C2.53896 24.5455 1.76623 23.8295 1.76623 22.9091V3.27273C1.76623 2.40341 2.53896 1.63636 3.53247 1.63636H17.6623C18.6007 1.63636 19.4286 2.40341 19.4286 3.27273V22.9091Z"
      fill={props.fill ?? "#2C1789"}
    />
  </svg>
)
